var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"event-item",staticClass:"event-item",style:({
    borderColor: _vm.borderColor,
    backgroundColor: _vm.backgroundColor,
    left: `${_vm.positionX}%`,
    width: `${_vm.width}%`,
  }),on:{"click":function($event){return _vm.$emit('click')},"mouseenter":(e) => _vm.$emit('hover', e),"mouseleave":(e) => _vm.$emit('hover', e)}},[_c('div',{staticClass:"event-item__container"},[_c('div',{staticClass:"event-item__number"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.contents),function(content,index){return _c('div',{key:`content-${index}`,staticClass:"event-item__content row-item",domProps:{"innerHTML":_vm._s(content)}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }